// Balises SEO par page. Le site est une SPA : index.html ne porte que les valeurs par
// défaut (et les balises Open Graph lues par Facebook, qui n'exécute pas le JS) ; titre,
// description, canonical et robots sont ensuite ajustés à chaque navigation (router
// afterEach). Google exécute le JS et indexe ces valeurs. Le canonical pointe toujours sur
// dartshub.fr : le même front est aussi servi sur www.dartshub.fr et auth.dartshub.fr.

export const SITE_URL = 'https://dartshub.fr';
export const SITE_NAME = 'DartsHub';
export const DEFAULT_DESCRIPTION =
  "DartsHub, la plateforme de la communauté fléchettes : licences, calendrier des tournois et inscriptions en ligne, avec un seul compte pour tout.";

export interface SeoOptions {
  title?: string;
  description?: string;
  path?: string;
  noindex?: boolean;
  image?: string | null;
}

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertCanonical = (href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const applySeo = ({ title, description, path = '/', noindex = false, image }: SeoOptions) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Licences, tournois et inscriptions fléchettes`;
  const desc = description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${path}`;

  document.title = fullTitle;
  upsertMeta('name', 'description', desc);
  upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
  upsertCanonical(url);
  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', desc);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:image', image || `${SITE_URL}/banner.png`);
};

// Données structurées (JSON-LD) propres à une page, identifiées pour pouvoir être
// remplacées ou retirées quand on la quitte.
export const setJsonLd = (id: string, data: Record<string, unknown> | null) => {
  const selector = `script[type="application/ld+json"][data-seo="${id}"]`;
  document.head.querySelector(selector)?.remove();
  if (!data) return;
  const el = document.createElement('script');
  el.type = 'application/ld+json';
  el.dataset.seo = id;
  el.textContent = JSON.stringify(data);
  document.head.appendChild(el);
};
